import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VPopover } from "v-tooltip";
import tinyColor from "tinycolor2";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { mapMutations } from "vuex";
import { TOGGLE_TRIGGER_COLLAPSE } from "../store/automation-mutations";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AutomationTypeHeader",
  components: {
    VPopover
  },
  props: {
    trigger: {
      type: Object,
      default: () => ({})
    },
    titleProperties: {
      type: Object,
      default: () => ({})
    },
    boardLevel: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showAdditionalInfo: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapFields("AutomationStore", ["collapseTriggers"])), {}, {
    triggerName() {
      return this.trigger.name;
    },
    headerStyle() {
      const bgColor = tinyColor(this.trigger.style["background-color"]);
      return {
        "border-left-color": `${bgColor.darken(bgColor.isDark() ? 0 : 100)} !important`
      };
    },
    textColor() {
      const bgColor = tinyColor(this.trigger.style["background-color"]);
      return {
        color: bgColor,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: bgColor,
        borderRadius: "20px"
      };
    },
    subtitleColor() {
      const bgColor = tinyColor(this.trigger.style["background-color"]);
      let colorToUse = `#767676 !important`;
      if (bgColor._originalInput === "#5f5b6b") colorToUse = "#fafafa";
      return {
        color: colorToUse
      };
    },
    caretClass() {
      return `fa ${this.collapseTriggers[this.trigger.key] ? "fa-caret-down" : "fa-caret-right"}`;
    },
    triggerTitle() {
      const path = `automations.triggersTitles.${this.trigger.key}`;
      return this.$t(path) !== path ? this.$t(path) : `${this.titleProperties.titlePrefix || ""} ${this.trigger.name} ${this.titleProperties.titleSuffix || ""}`;
    },
    triggerSubtitle() {
      const path = `automations.triggersSubtitles.${this.trigger.key}`;
      if (path !== this.$t(path)) return this.$t(path);
      const {
        subtitlePrefix = "",
        subtitleSuffix = ""
      } = this.titleProperties;
      const desciptionToUse = this.trigger.description || this.triggerName;
      return `${subtitlePrefix} ${desciptionToUse} ${subtitleSuffix}`;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations("AutomationStore", [TOGGLE_TRIGGER_COLLAPSE])), {}, {
    toggleCollapse() {
      this.TOGGLE_TRIGGER_COLLAPSE(this.trigger.key);
    }
  })
});